export const labels = {
  pcmcLabel: {
    en: "Pimpri Chinchwad Municipal Corporation, Pimpri - 411018",
    ma: "पिंपरी चिंचवड महानगरपालिका,पिंपरी - ४११०१८",
  },
  rupee: {
    en: "₹",
    ma: "₹",
  },
  NameHolder: {
    en: "Name of Income Holder",
    ma: "मिळकत धारकाचे नाव",
  },
  GroupNumber: {
    en: "Group Number",
    ma: "गट क्रमांक",
  },
  PropertLevyReceipt: {
    en: "Property Levy Receipt",
    ma: "मालमत्ता आकारणी पावती",
  },
  Zone: {
    en: "Zone",
    ma: "झोन",
  },
  FromDate: {
    en: "From Date",
    ma: "दिनांक पासून",
  },
  Counter: {
    en: "Counter",
    ma: "भरणा केंद्र",
  },
  ToDate: {
    en: "To Date",
    ma: "दिनांक पर्यंत",
  },
  ReceiptDate: {
    en: "Receipt Date",
    ma: "पावती दिनांक",
  },
  CounterNo: {
    en: "Counter No",
    ma: "भरणा केंद्र क्रं",
  },
  PropertyNumber: {
    en: "Property Number",
    ma: "मालमता क्र.",
  },
  PropertyName: {
    en: "Property Name",
    ma: "मालमत्तेचे नाव",
  },
  PropertyCode: {
    en: "Property Code",
    ma: "मालमत्तेचे कोड",
  },
  GatNumber: {
    en: "Gate Number",
    ma: "गट क्रमांक",
  },
  Address: {
    en: "Address",
    ma: "पत्ता",
  },
  propertyAddress: {
    en: "Property Address",
    ma: "मालमत्ता पत्ता",
  },
  MobileNo: {
    en: "Mobile No",
    ma: "दूरध्वनी क्रमांक",
  },
  PaymentMode: {
    en: "Payment Mode",
    ma: "देयक प्रकार",
  },
  ModeOfPayment: {
    en: "Mode of Payment",
    ma: "देयक प्रकार",
  },
  receivedPaymentMode: {
    en: "Mode of Payment",
    ma: "भरणा प्रकार",
  },
  ChequeNumber: {
    en: "Cheque Number",
    ma: "धनादेश क्रमांक",
  },
  BankName: {
    en: "Bank Name",
    ma: "बैंक नाव",
  },
  ChequeDate: {
    en: "Cheque Date",
    ma: "धनादेश तारीख",
  },
  BankArea: {
    en: "Bank Area",
    ma: "बैंक एरिया",
  },
  ConcessionType: {
    en: "Concession Type",
    ma: "सवलत प्रकार",
  },
  BillAmount: {
    en: "Bill Amount",
    ma: "बिल रक्कम",
  },
  BillNumber: {
    en: "Bill Number",
    ma: "बिल क्रमांक",
  },
  IllegalPropertyAdjustmentAmount: {
    en: "Illegal Property Adjustment Amount",
    ma: "अवैध बांधकाम समायोजन रक्कम",
  },
  ExtraPaidAmount: {
    en: "Extra Paid Amount",
    ma: "फाजिल रक्कम",
  },
  ConcessionAmount: {
    en: "Concession Amount",
    ma: "सवलत रक्कम",
  },
  PaidAmount: {
    en: "Paid Amount",
    ma: "भरणा",
  },
  BalanceAmount: {
    en: "Balance Amount",
    ma: "निव्वळ थकीत",
  },
  SrNo: {
    en: "Sr.No",
    ma: "अ.क्र.",
  },
  ConsumerNumber: {
    en: "Consumer Number",
    ma: "ग्राहक क्रमांक",
  },
  ConsumerName: {
    en: "Consumer Name",
    ma: "ग्राहक नाव",
  },
  FYear: {
    en: "FYear",
    ma: "आर्थिक वर्ष",
  },
  occupantName: {
    en: "occupant Name",
    ma: "भोगवटधारकाचे नाव",
  },
  Placeofpayment: {
    en: "Place of payment",
    ma: "भरणा ठिकाण",
  },
  AreaReceiptNumber: {
    en: "Area Receipt Number",
    ma: "क्षेत्र पावती क्रमांक",
  },
  CancelReceiptDashBoard: {
    en: "Cancel Receipt DashBoard",
    ma: "रद्द पावती डॅशबोर्ड",
  },
  Remark: {
    en: "Remark",
    ma: "शेरा",
  },
  Cancel: {
    en: "Cancel",
    ma: "रद्द",
  },
  Reset: {
    en: "Reset",
    ma: "पूर्ववत ",
  },
  Action: {
    en: "Action",
    ma: "कृती",
  },
  ReceiptType: {
    en: "Receipt Type",
    ma: "पावती प्रकार",
  },
  PREFILLEDCHALLAN: {
    en: "PREFILLED CHALLAN",
    ma: "आधीच भरलेले चलन",
  },
  noOfBudgetHeads: {
    en: "No.Of budget Heads",
    ma: "अंदाजपत्रक प्रमुखांची संख्या",
  },
  BudgetHeadName: {
    en: "Budget Head Name",
    ma: "अंदाजपत्रक प्रमुखांच नाव",
  },
  UserName: {
    en: "User Name",
    ma: "वापरकर्ता नाव",
  },
  GetEDCTransactionStatus: {
    en: "Get EDC Transaction Status",
    ma: "EDC व्यवहार स्थिती मिळवा",
  },
  stampStockRegister: {
    en: "Stamp Stock Register",
    ma: "मुद्रांक साठा नोंदणी",
  },
  revenueStampReport: {
    en: "Revenue Stamp Report",
    ma: "महसूल मुद्रांक अहवाल",
  },
  costPerStamp: {
    en: "Cost Per Stamp",
    ma: "मुद्रांक प्रति खर्च",
  },
  noOfStamps: {
    en: "No of Stamp",
    ma: "मुद्रांक संख्या",
  },
  remainingStamps: {
    en: "Remaining Stamp",
    ma: "बाकी मुद्रांक",
  },
  receiveDate: {
    en: "Receive Date",
    ma: "प्राप्त दिनांक",
  },
  CounterName: {
    en: "Counter Name",
    ma: "भरणा केंद्र नाव",
  },
  costOfStamp: {
    en: "Cost of Stamp",
    ma: "मुद्रांकची किंमत",
  },
  balStamp: {
    en: "Balance Stamp",
    ma: "Balance मुद्रांक",
  },
  currentStock: {
    en: "Current Stock",
    ma: "चालू साठा",
  },
  transactionDate: {
    en: "Transaction Date",
    ma: "व्यवहार दिनांक",
  },
  PlutusTxnRefID: {
    en: "Plutus Txn Ref ID",
    ma: "Plutus Txn संदर्भ आयडी",
  },
  SelectAll: {
    en: "Select All",
    ma: "सर्व निवडा",
  },
  "ZonalRecNo.": {
    en: "Zonal Rec No.",
    ma: "झोन पावती क्रमांक",
  },
  PaymentChallan: {
    en: "Payment Challan",
    ma: "भरणा चलन",
  },
  ReceiptAmount: {
    en: "Receipt Amount",
    ma: "पावती रक्कम",
  },
  chequeDate: {
    en: "cheque Date",
    ma: "धनादेश दिनांक",
  },
  ReceiptCount: {
    en: "Receipt Count",
    ma: "पावती गणना",
  },
  ReceiptStatus: {
    en: "Receipt Status",
    ma: "पावती स्थिती",
  },
  Date: {
    en: "Date",
    ma: "दिनांक",
  },
  ReceiptNumber: {
    en: "Receipt Number",
    ma: "पावती क्रमांक",
  },
  ZoneReceiptNumber: {
    en: "Zone Receipt Number",
    ma: "प्रभाग पावती क्रमांक",
  },
  zonewiseReceiptReport: {
    en: "Zonewise Daily Receipt Report",
    ma: "Zonewise Daily Receipt Report",
  },
  MalakName: {
    en: "Owner name",
    ma: "मालकाचे नाव",
  },
  CounterType: {
    en: "Counter Type",
    ma: "भरणा प्रकार",
  },
  Year: {
    en: "Year",
    ma: "सन",
  },
  AmtInWordNote: {
    en: "In this year amount in words",
    ma: "या वर्षात खालील प्रमाणे रक्कम रुपये अक्षरी",
  },
  TaxName: {
    en: "Tax Name",
    ma: "कराचे नाव",
  },
  Pre: {
    en: "Previous",
    ma: "मागील",
  },
  Curr: {
    en: "Current",
    ma: "चालू",
  },
  Total: {
    en: "Total",
    ma: "एकूण",
  },
  ChequeDDNumber: {
    en: "Chq.No/DD No",
    ma: "चेक/डीडी क्र.",
  },
  ChequeDDDate: {
    en: "Chq/DD Date",
    ma: "चेक/डीडी तारीख",
  },
  ChequeDDAmount: {
    en: "Chq/DD Amount",
    ma: "चेक/डीडी रक्कम",
  },
  CancelReceipt: {
    en: "Cancel Receipt",
    ma: "रद्द पावती",
  },
  CancelReceiptDashboard: {
    en: "Cancel Receipt Dashboard",
    ma: "रद्द पावती डॅशबोर्ड",
  },
  ActiveReceipt: {
    en: "Active Receipt",
    ma: "सक्रिय पावती",
  },
  Amount: {
    en: "Amount",
    ma: "रक्कम",
  },
  Receipt: {
    en: "Receipt",
    ma: "पावती",
  },
  PotkirdForBillReceipt: {
    en: "Potkird For Bill Receipt",
    ma: "पोटकीर्द बिल पावती",
  },
  PotkirdReport: {
    en: "Potkird Report",
    ma: "पोटकीर्द अहवाल",
  },
  SrNoShort: {
    en: "Sr.No",
    ma: "अ.क्र.",
  },
  Gat: {
    en: "Ward",
    ma: "गट",
  },
  Fagil: {
    en: "Fagil",
    ma: "फाजील",
  },
  ManagmentTax: {
    en: "प्रशासकीय सेवा शुल्क",
    ma: "प्रशासकीय सेवा शुल्क",
  },
  GeneralTax: {
    en: "General Tax",
    ma: "सामान्य कर",
  },
  TreeTax: {
    en: "Tree Tax",
    ma: "वृक्ष उपकर",
  },
  SewerageTax: {
    en: "Sewerage Tax",
    ma: "मलप्रवाह कर",
  },
  WaterTax: {
    en: "Water Tax",
    ma: "पाणी पुरवठा",
  },
  RoadTax: {
    en: "Road Tax",
    ma: "रस्ता कर",
  },
  VisheshSafSafaiKar: {
    en: "Vishesh Saf Safai Kar",
    ma: "विशेष साफसफाई कर",
  },
  EducationTax: {
    en: "Education Tax",
    ma: "शिक्षण कर",
  },
  RojgarKar: {
    en: "Rojgar Kar",
    ma: "रोजगार कर",
  },
  FlorageTax: {
    en: "Florage Tax",
    ma: "फ़्लोअरेज कर",
  },
  FlorageTaxNoticeFee: {
    en: "Florage Tax Notice Fee",
    ma: "फ़्लोअरेज कर नोटीस फि",
  },
  RojgarNoticeFee: {
    en: "Rojgar Notice Fee",
    ma: "रोजगार नोटीस फि",
  },
  ManapaKar: {
    en: "MA NA PA Fee",
    ma: "म. न. पा. कर",
  },
  EducationTaxNoticeFee: {
    en: "Education Tax Notice Fee",
    ma: "शिक्षण कर नोटीस फि",
  },
  FagilVasuli: {
    en: "Fagil Vasuli",
    ma: "फाजील वसुली",
  },
  IllegalBaandhkamShhasti: {
    en: "Illegal Baandhkam Shhasti",
    ma: "अवैध बांधकाम शास्ती",
  },
  Other: {
    en: "Other",
    ma: "इतर",
  },
  PreviousTotal: {
    en: "Previous Total",
    ma: "मागील एकूण",
  },
  CurrentTotal: {
    en: "Current Total",
    ma: "चालू एकूण",
  },
  Details: {
    en: "Details",
    ma: "तपशील",
  },
  sankhya: {
    en: "Count",
    ma: "संख्या",
  },
  RakkamRupaye: {
    en: "Amount in Rs",
    ma: "रक्कम रुपये",
  },
  Rokh: {
    en: "Cash",
    ma: "रोख",
  },
  Bank: {
    en: "Bank",
    ma: "बँक",
  },
  ChallanNo: {
    en: "Challan No",
    ma: "चलन क्र.",
  },
  Naanewari: {
    en: "Coinage",
    ma: "नाणेवारी",
  },
  Rupaye: {
    en: "Rs",
    ma: "रुपये",
  },
  Vibhag: {
    en: "Department",
    ma: "विभाग",
  },
  ViewChallan: {
    en: "View Challan (Cash,Cheque,DD)",
    ma: "चलन पहा (कॅश, डीडी, चेक)",
  },
  ChallanDate: {
    en: "Challan Date",
    ma: "चलन दिनांक",
  },
  AccountNo: {
    en: "Account No",
    ma: "खाते क्र.",
  },
  BillReceipt: {
    en: "Bill Receipt",
    ma: "बिल पावती",
  },
  PerfilledBillReceipt: {
    en: "Perfilled Bill Receipt",
    ma: "पूर्ण केले बिल पावती",
  },
  voterLabel: {
    ma: "मतदार यादीत नाव नाही, ही तक्रारच संपवू या",
    en: "मतदार यादीत नाव नाही, ही तक्रारच संपवू या",
  },
  tax41: {
    ma: "अनादर धनादेश सेवा शुल्क",
    en: "अनादर धनादेश सेवा शुल्क",
  },
  tax12: {
    ma: "थकबाकी नसलेचा दाखला फ़ी",
    en: "थकबाकी नसलेचा दाखला फ़ी",
  },
  tax47: {
    ma: "हस्तांतरण फी विलंब शुल्क",
    en: "हस्तांतरण फी विलंब शुल्क",
  },
  tax46: {
    ma: "लेखा परिक्षण आक्षेप पुर्तता",
    en: "लेखा परिक्षण आक्षेप पुर्तता",
  },
  tax42: {
    en: "माहिती अधिकार फी",
    ma: "माहिती अधिकार फी",
  },
  tax37: {
    ma: "इतर",
    en: "इतर",
  },
  tax40: {
    ma: "नक्कल फ़ी",
    en: "नक्कल फ़ी",
  },
  tax11: {
    ma: "हस्तांतर नोटीस फी",
    en: "हस्तांतर नोटीस फी",
  },
  tax13: {
    ma: "मालमत्ता उतारा फी",
    en: "मालमत्ता उतारा फी",
  },
  oldMobNum: {
    ma: "Existing Mobile Number",
    en: "Existing Mobile Number",
  },
  oldEmail: {
    ma: "Existing Email Id",
    en: "Existing Email Id",
  },
  emailId: {
    ma: "ईमेल",
    en: "Email",
  },
  newMobNum: {
    ma: "New Mobile Number",
    en: "New Mobile Number",
  },
  newEmail: {
    ma: "New Email Id",
    en: "New Email Id",
  },
  addMobTitle: {
    ma: "मालमत्तेस मोबाईल क्रमांक जोडा",
    en: "Link your property with mobile number",
  },
  GeneralReceiptDetails: {
    ma: "सामान्य पावती तपशील",
    en: "General Receipt Details",
  },
  BillReceiptDetails:{
    ma: "बिल पावती तपशील",
    en: "Bill Receipt Details",
  },
  ZonewiseReceiptList:{
    ma: "झोन पावती तपशील",
    en: "Zonewise Receipt List",
  },
  BillReceiptTotal: {
    en: "Bill Receipt Total",
    ma: "बिल पावती एकूण",
  },
  ZoneReceiptTotal:{
    ma: "सामान्य पावती एकूण",
    en: "General Receipt Total",
  },
  NoRecordFound:{
    ma: "माहिती उपलब्ध नाही",
    en: "No Records Found",
  }
};
